import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HeadersService } from './api/headers/headers.service';

interface GenerateBusinessEmailResponse {
  email_body?: string;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class BusinessEmailService {

  constructor(private http: HttpClient, private headersService: HeadersService) { }

  generateBusinessEmail(
    contentType: string, docId: string, digestResultsId?: string, recipient?: {name: string, position: string}
  ): Promise<GenerateBusinessEmailResponse> {
    return firstValueFrom(this.http.post<GenerateBusinessEmailResponse>(
      environment.explainApiGatewayUrl + 'generate-email',
      {
        doc_id: docId,
        digest_results_id: digestResultsId,
        content_type: contentType,
        recipient
      },
      {
        ...this.headersService.httpHeaders,
        responseType: 'json'
      }
    ));
  }
}
